import { render, staticRenderFns } from "./workers.vue?vue&type=template&id=0edd3ee1&scoped=true&"
import script from "./workers.vue?vue&type=script&lang=js&"
export * from "./workers.vue?vue&type=script&lang=js&"
import style0 from "./workers.vue?vue&type=style&index=0&id=0edd3ee1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edd3ee1",
  null
  
)

export default component.exports